import { createAsyncThunk } from '@reduxjs/toolkit'
import { ClientType } from '../slices/clientsSlice'
import axios, { AxiosError } from 'axios'
import { ErrorLogItem, Subscriber } from '../types'
//import { firestore } from '../../Firebase'
// import { doc, getDoc, updateDoc } from 'firebase/firestore'
import { toast } from 'react-toastify'
import { getAuth } from 'firebase/auth'
import { getUsersLastLogin } from '../../api/awsApis'

const SERVER_URL = "https://us-central1-elisyanwealth.cloudfunctions.net/";
const BASE_URL =
  "http://127.0.0.1:5001/elisyanwealth/us-central1/";

// updateUsersAction now drives the v2 client<->advisor relationship
// endpoints (functions/v2/endpoints/clientAdvisorRelationshipEndpoints.ts →
// linkClientAdvisors_v2 / unlinkClientAdvisors_v2). Those transactionally
// keep advisors[]/clients[]/sharing[]/shared[] on users_v2 consistent, write
// the sharingAssignments_v2 history, AND make the real AWS backup-access
// grant/revoke call server-side — so the client-side createAwsAccess /
// deleteAwsAccess calls below are no longer used from here. Same for
// updateClientId / assignClientId / fetchAssignableClientIds
// (partnerClientId-linked clientId add/rename).
// Pointed at BASE_URL (functions emulator) for pre-deploy testing; set
// CLIENTS_V2_DEPLOYED = true once the corresponding `_v2` functions are live.
const CLIENTS_V2_DEPLOYED = true;
const CLIENTS_V2_URL = CLIENTS_V2_DEPLOYED ? SERVER_URL : BASE_URL;
// export const getClientsAction = createAsyncThunk<
//   ClientType[] | undefined,
//   { business_names: string[] | undefined }
// >('clients_slice/getClientsAction', async ({ business_names }, thunkAPI) => {
//   try {
//     const response = await axios.post(
//       //"http://127.0.0.1:5001/elisyanwealth/us-central1/getClientsByBusinesses",
//      'https://us-central1-elisyanwealth.cloudfunctions.net/getClientsByBusinesses',
//       { business_names: business_names },
//       {
//         headers: {
//           'Content-Type': 'application/json',
//         },
//       },
//     )
//     // console.log('get clients list' , business_names, response)
//     return response.data.data
//   } catch (e) {
//     //  console.log('-------------- Error register User Device Token' + e);
//     return thunkAPI.rejectWithValue(e)
//   }
// })

export const getClientsAction = createAsyncThunk<
  ClientType[] | undefined,
  { business_names: string[] | undefined; token: string }
>(
  'clients_slice/getClientsAction',
  async ({ business_names, token }, thunkAPI) => {
    try {
        // Get the current user's token directly from Firebase Auth
        const auth = getAuth();
        const user = auth.currentUser;
        
        if (!user) {
          return thunkAPI.rejectWithValue('User not authenticated');
        }
        
        // Get fresh token (Firebase automatically refreshes if needed)
        const token = await user.getIdToken();
      const response = await axios.post(
        //'http://127.0.0.1:5001/elisyanwealth/us-central1/getClientsByBusinesses',
       `${CLIENTS_V2_URL}getClientsByBusinesses_v2`,
        { business_names },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`, // ✅ include token here
          },
        },
      );

      return response.data.data;
    } catch (e) {
      console.error('Error fetching clients:', e);
      if (e instanceof AxiosError && e.response?.data?.message) {
        return thunkAPI.rejectWithValue(e.response.data.message);
      }
      return thunkAPI.rejectWithValue(
        'Unexpected error occurred while fetching clients.',
      );
    }
  },
);


export type ClientActivityType =  Record<string, {lastLogin: string}> | undefined

export const getClientsActivityAction = createAsyncThunk<
  { usersWithLastActivity: Record<string, { loginTime: number }>; usersWithNoSnapshots: string[]; status: 'error'|'success' } | undefined,
  { userIds: string[] }
>(
  'clients_slice/getClientsActivityAction',
  async ({ userIds }, thunkAPI) => {
    try {
        // Get the current user's token directly from Firebase Auth
        const auth = getAuth();
        const user = auth.currentUser;
        
        if (!user) {
          return thunkAPI.rejectWithValue('User not authenticated');
        }
        
        // Get fresh token (Firebase automatically refreshes if needed)
        const token = await user.getIdToken();
        const res = await getUsersLastLogin(userIds);
        if(res && res.status === 'success'){
          return res
        }
      return res;
    } catch (e) {
      console.error('Error fetching clients:', e);
      if (e instanceof AxiosError && e.response?.data?.message) {
        return thunkAPI.rejectWithValue(e.response.data.message);
      }
      return thunkAPI.rejectWithValue(
        'Unexpected error occurred while fetching clients.',
      );
    }
  },
);



type Guest = {
  guestId: string
}
type SharingArgs = {
  ownerId: string
  sharing: Guest[]
}
export const createAwsAccess = (sharing: SharingArgs) => {
  try {
    axios.post(
      'https://b14h7isg51.execute-api.eu-west-2.amazonaws.com/staging/bckp/access',
      { ...sharing },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  } catch (e) {
    console.log('===>error on create access object on aws')
    throw e
  }
}

export const deleteAwsAccess = async (sharing: SharingArgs) => {
  try {
    const response = await axios.delete(
      'https://b14h7isg51.execute-api.eu-west-2.amazonaws.com/staging/bckp/access',
      {
        headers: {
          'Content-Type': 'application/json',
        },
        data: { ...sharing }, // Include the data in the config object
      },
    )
    console.log('response from delete access object', response)
  } catch (e) {
    console.log('===>error on delete access object on aws')
    throw e
  }
}
export type SharingItem = {
  guestId: string
}
export type Sharing = {
  ownerId: string
  sharing: SharingItem[]
}
export type UpdateUsersArgs = {
  users: ClientType[]
  sharingToCreate?: Sharing
  SharingToDelete?: Sharing[]
}

export const updateUsersAction = createAsyncThunk<
  ClientType[] | undefined,
  UpdateUsersArgs
>(
  'clients_slice/updateUsersAction',
  async ({ users, sharingToCreate, SharingToDelete }, thunkAPI) => {
    try {
      const auth = getAuth()
      const currentUser = auth.currentUser
      if (!currentUser) {
        return thunkAPI.rejectWithValue('User not authenticated')
      }
      const token = await currentUser.getIdToken()

      // Both detail screens (clientDetails2 / advisorDetails) build the
      // sharing objects the same way: ownerId = the CLIENT's app_user_id,
      // each sharing[].guestId = an ADVISOR's app_user_id. The full user
      // objects they also pass in `users` carry both `id` (the users_v2 doc
      // id) and `app_user_id`, so every referenced participant resolves.
      const docIdByAppUserId = new Map<string, string>()
      users.forEach((u) => {
        if (u.app_user_id) docIdByAppUserId.set(u.app_user_id, u.id)
      })

      const toPairs = (s: Sharing): { clientId: string; advisorId: string }[] =>
        (s.sharing || [])
          .map((item) => ({
            clientId: docIdByAppUserId.get(s.ownerId) as string,
            advisorId: docIdByAppUserId.get(item.guestId) as string,
          }))
          .filter((p) => Boolean(p.clientId && p.advisorId))

      const links = sharingToCreate
        ? toPairs(sharingToCreate).map((p) => ({
            ...p,
            permission: [{ permissions: ['read', 'write'] }],
          }))
        : []
      const unlinks = (SharingToDelete || []).flatMap(toPairs)

      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }
      type PairResult = { clientId: string; advisorId: string; ok: boolean; error?: string }
      const results: PairResult[] = []

      if (links.length > 0) {
        const res = await axios.post(`${CLIENTS_V2_URL}linkClientAdvisors_v2`, { links }, { headers })
        results.push(...((res.data?.data as PairResult[]) ?? []))
      }
      if (unlinks.length > 0) {
        const res = await axios.post(`${CLIENTS_V2_URL}unlinkClientAdvisors_v2`, { unlinks }, { headers })
        results.push(...((res.data?.data as PairResult[]) ?? []))
      }

      const failed = results.filter((r) => !r.ok)
      if (failed.length > 0) {
        console.log('updateUsersAction: some pairs failed', failed)
        return thunkAPI.rejectWithValue(
          failed.map((f) => f.error).filter(Boolean).join('; ') || 'Some advisor assignments failed',
        )
      }

      // Return the frontend-computed objects for the optimistic slice
      // update — v2 link/unlink recomputes the same arrays server-side, so
      // this matches the persisted state until the next re-fetch.
      return users
    } catch (e) {
      console.log('-------------- Error Update user' + e)
      return thunkAPI.rejectWithValue(e)
    }
  },
)

//modifying client Id
// export const updateClientIdOld = createAsyncThunk<
//   { clientDocId: string; clientId: string } | undefined,
//   { clientDocId: string; clientId: string }
// >(
//   'clients_slice/updateClientId',
//   async ({ clientDocId, clientId }, thunkAPI) => {
//     try {
//       // Ensure firestore is initialized and clientDocId is valid
//       if (!clientDocId) throw new Error('clientDocId is required')

//       const clientRef = doc(firestore, 'users', clientDocId)

//       await updateDoc(clientRef, { clientId: clientId })
//       toast.success('Client ID updated successfully!')
//       return { clientDocId: clientDocId, clientId }
//     } catch (e) {
//       console.error('Error updating clientId:', e)
//       return thunkAPI.rejectWithValue({
//         message: 'Error updating clientId',
//         error: e,
//       })
//     }
//   },
// )

// Renames the partnerClientId bucket a client belongs to (v2
// renameUserClientId_v2 — dup-checked against the business's other buckets,
// cascades the new clientId to every user in that bucket). `oldClientId` is
// only used client-side, to update every sibling client already showing the
// old value in the redux `clients` list (see the slice reducer).
export const updateClientId = createAsyncThunk<
  { clientDocId: string; clientId: string; oldClientId?: string } | undefined,
  { clientDocId: string; clientId: string; oldClientId?: string }
>(
  'clients_slice/updateClientId',
  async ({ clientDocId, clientId, oldClientId }, thunkAPI) => {
    try {
      const user = getAuth().currentUser
      if (!user) return thunkAPI.rejectWithValue({ message: 'Not authenticated' })
      const token = await user.getIdToken()

      const res = await fetch(
        `${CLIENTS_V2_URL}renameUserClientId_v2`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ userId: clientDocId, newClientId: clientId }),
        },
      )

      const { data, message } = await res.json()
      if (!res.ok) throw new Error(message || 'Failed to update client ID')

      toast.success('Client ID updated successfully!')
      return { clientDocId, clientId: data.clientId as string, oldClientId }
    } catch (e) {
      const message = e instanceof Error ? e.message : 'Error updating clientId'
      console.error('Error updating clientId:', e)
      return thunkAPI.rejectWithValue({ message, error: e })
    }
  },
)

export interface AssignableClientId {
  id: string
  clientId: string
  type: string
  users_count: number
  users_limit: number
}

/** Buckets a client can be assigned to — for the "Add Client ID" searchable
 * select (AddClientIDModal.tsx). Not deleted, not canceled, has spare
 * capacity, owned by the client's own business. */
export async function fetchAssignableClientIds(
  businessName: string,
): Promise<AssignableClientId[]> {
  const authUser = getAuth().currentUser
  if (!authUser) throw new Error('Not authenticated')
  const token = await authUser.getIdToken()

  const res = await fetch(`${CLIENTS_V2_URL}listAssignablePartnerClientIds_v2`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ businessName }),
  })
  const json = await res.json()
  if (!res.ok) throw new Error(json?.message || 'Failed to load available client IDs')
  return (json.data || []) as AssignableClientId[]
}

// "Add Client ID" confirm — links an existing (already-active) client to an
// existing partnerClientId bucket, the same way a signup-by-clientId does:
// v2 assignPartnerClientIdToUser_v2 increments the bucket's users_count and
// writes partnerClientId ref + clientId onto the user doc.
export const assignClientId = createAsyncThunk<
  { clientDocId: string; clientId: string } | undefined,
  { clientDocId: string; partnerClientIdId: string }
>(
  'clients_slice/assignClientId',
  async ({ clientDocId, partnerClientIdId }, thunkAPI) => {
    try {
      const authUser = getAuth().currentUser
      if (!authUser) return thunkAPI.rejectWithValue({ message: 'Not authenticated' })
      const token = await authUser.getIdToken()

      const res = await fetch(`${CLIENTS_V2_URL}assignPartnerClientIdToUser_v2`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ userId: clientDocId, partnerClientIdId }),
      })
      const { data, message } = await res.json()
      if (!res.ok) throw new Error(message || 'Failed to assign client ID')

      toast.success('Client ID assigned successfully!')
      return { clientDocId, clientId: data.clientId as string }
    } catch (e) {
      const message = e instanceof Error ? e.message : 'Error assigning client ID'
      console.error('Error assigning clientId:', e)
      return thunkAPI.rejectWithValue({ message, error: e })
    }
  },
)

export const getAdvisorsAction = createAsyncThunk<
  ClientType[] | undefined,
  { business_names: string[] | undefined }
>('clients_slice/getAdvisorsAction', async ({ business_names }, thunkAPI) => {
  try {
       // Get the current user's token directly from Firebase Auth
       const auth = getAuth();
       const user = auth.currentUser;
       
       if (!user) {
         return thunkAPI.rejectWithValue('User not authenticated');
       }
       
       // Get fresh token (Firebase automatically refreshes if needed)
       const token = await user.getIdToken();

    // console.log('inputs', business_name);
    //http://127.0.0.1:5001/elisyanwealth/us-central1/getAdvisors
    //https://getadvisors-c5yieuvjca-uc.a.run.app
    const response = await axios.post(
       //'http://127.0.0.1:5001/elisyanwealth/us-central1/getAdvisorsByBusinesses',
      `${CLIENTS_V2_URL}getAdvisorsByBusinesses_v2`,
      { business_names },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`, // ✅ include token here
        },
      },
    )
    // console.log(' get advisors list' , response)
    return response.data.data
  } catch (e) {
    // console.log('-------------- Error register User Device Token' + e);
    return thunkAPI.rejectWithValue(e)
  }
})

// export const getSubscriberSummary = createAsyncThunk<
//   Subscriber | undefined,
//   {userId:string | undefined}
// >(
//   'clients_slice/getSubscriberSummary',
//   async ({ userId }, thunkAPI) => {
//     try {
//      // console.log('inputs', business_name);
//       //http://127.0.0.1:5001/elisyanwealth/us-central1/getClients

//       //https://us-central1-elisyanwealth.cloudfunctions.net/getSubscriberSummary

//         const response = await axios.post('http://127.0.0.1:5001/elisyanwealth/us-central1/getSubscriberSummary', {app_user_id: userId}, {
//         headers: {
//         'Content-Type': 'application/json',
//         }});
//        console.log('get subscriber data list' , response)
//         return response.data.data;
//     } catch (e) {
//       console.log('-------------- Error get subscriber data' + e);
//       if(e instanceof AxiosError && e?.response && e.response.data)
//       return thunkAPI.rejectWithValue(e.response.data.message);
//     }
//   }
// );

// export const getSubscriberSummary = createAsyncThunk<
//   Subscriber[], // Expecting an array of subscribers in response
//   { userIds: string[] } // Accept a list of userIds
// >(
//   'clients_slice/getSubscriberSummary',
//   async ({ userIds }, thunkAPI) => {
//     try {
//       const response = await axios.post(
//         'http://127.0.0.1:5001/elisyanwealth/us-central1/getSubscriberSummary',
//         { app_user_ids: [...userIds] }, // send as an array
//         { headers: { 'Content-Type': 'application/json' } }
//       );

//       console.log('Received subscriber list:', response);
//       return response.data.success; // assumed to be an array of Subscriber objects
//     } catch (e) {
//       console.error('Error in getSubscriberSummary:', e);
//       if (e instanceof AxiosError && e.response && e.response.data) {
//         return thunkAPI.rejectWithValue(e.response.data.message);
//       }
//       return thunkAPI.rejectWithValue('Unexpected error occurred.');
//     }
//   }
// );

export const getSubscriberSummary = createAsyncThunk<
  Record<string, Subscriber>, // return: map of userId -> Subscriber
  { userIds: string[] } // input: list of userIds
>('clients_slice/getSubscriberSummary', async ({ userIds }, thunkAPI) => {
  //
  // Drop blank/undefined ids (pending or partially-migrated users have no
  // app_user_id) and dedupe — an empty string in the list makes the
  // downstream service 500 / DynamoDB reject the batch.
  const cleanIds = Array.from(
    new Set((userIds ?? []).filter((id) => typeof id === 'string' && id.trim() !== '')),
  )
  if (cleanIds.length === 0) {
    return {}
  }
  try {
      // Get the current user's token directly from Firebase Auth
      const auth = getAuth();
      const user = auth.currentUser;

      if (!user) {
        return thunkAPI.rejectWithValue('User not authenticated');
      }

      // Get fresh token (Firebase automatically refreshes if needed)
      const token = await user.getIdToken();
    const response = await axios.post(
     // 'http://127.0.0.1:5001/elisyanwealth/us-central1/getSubscriberSummary',
     'https://getsubscribersummary-c5yieuvjca-uc.a.run.app',
      { app_user_ids: cleanIds },
      { headers: { 
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      } },
    )

    const subscribers: Subscriber[] = response.data.success

    // Group by original_app_user_id
    const subscriberMap = subscribers.reduce<Record<string, Subscriber>>(
      (acc, sub) => {
        if (sub.original_app_user_id) {
          acc[sub.original_app_user_id] = sub
        }
        return acc
      },
      {},
    )

    return subscriberMap
  } catch (e) {
    console.error('Error in getSubscriberSummary:', e)
    if (e instanceof AxiosError && e.response?.data) {
      return thunkAPI.rejectWithValue(e.response.data.message)
    }
    return thunkAPI.rejectWithValue('Unexpected error occurred.')
  }
})

//https://api.revenuecat.com/v2/projects/{project_id}/customers/{customer_id}

// Async action to fetch error logs
export const fetchErrorLogs = createAsyncThunk<Record<string, ErrorLogItem[]>>(
  'errorLogs/fetchErrorLogs',
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(
        'https://b14h7isg51.execute-api.eu-west-2.amazonaws.com/staging/utilities/errors',
        {
          headers: {
            Authorization: `Bearer ${'domy-token'}`,
          },
        },
      )
      const items: ErrorLogItem[] = response.data.response.Items

      // Transform into a map grouped by userId
      const groupedByUserId = items.reduce<Record<string, ErrorLogItem[]>>(
        (acc, item) => {
          if (!acc[item.userId]) {
            acc[item.userId] = []
          }
          acc[item.userId].push(item)
          return acc
        },
        {},
      )

      return groupedByUserId
    } catch (err) {
      let message = 'Unknown error'
      if (err instanceof Error) {
        message = err.message
      }
      return thunkAPI.rejectWithValue(message)
    }
  },
)

export type ClientStatus =
  | 'Active - Free Trial'
  | 'Active - Monthly Subscription'
  | 'Active - Annual Subscription'
  | 'Active - Licence'
  | 'Inactive - Subscription Expired'
  | 'Inactive - Subscription Canceled'
  | 'Inactive - Licence Expired'
  | 'Inactive - No Subscription'

export function getClientStatus(
  userId: string,
  subscribers: Record<string, Subscriber>,
): ClientStatus {
  const subscriber = subscribers[userId]
  //console.log('££££subscriber:', subscriber, '££££userId:', userId)
  if (
    !subscriber ||
    !subscriber.entitlements ||
    Object.keys(subscriber.entitlements).length === 0
  ) {
    return 'Inactive - No Subscription' // or throw an error if preferred
  }

  const { entitlements, subscriptions } = subscriber
  const entitlementKey = Object.keys(entitlements)[0]
  const entitlement = entitlements[entitlementKey]

  const now = new Date()
  const expires = new Date(entitlement?.expires_date || '')
  const isActive = expires > now

  const subscription = subscriptions?.[entitlement?.product_identifier]
  const { period_type, unsubscribe_detected_at } = subscription || {}

  if (isActive) {
    if (period_type === 'trial') {
      return 'Active - Free Trial'
    } else if (entitlement.product_identifier?.includes('monthly')) {
      return 'Active - Monthly Subscription'
    } else if (entitlement.product_identifier?.includes('annual')) {
      return 'Active - Annual Subscription'
    } else {
      return 'Active - Licence'
    }
  } else {
    if (unsubscribe_detected_at) {
      return 'Inactive - Subscription Canceled'
    } else {
      return subscription
        ? 'Inactive - Subscription Expired'
        : 'Inactive - Licence Expired'
    }
  }
}
